import React, { useEffect, useState } from 'react';
import ErrorDetails from '../../knowledge-management/components/ErrorDetails.jsx';

// Campi facoltativi per profilo: il tempo trascorso serve a SA-2a/SA-2c,
// il progetto a SA-2b/SA-4. Confronto senza maiuscole/minuscole.
const PROFILI_CON_TEMPO = ['sa-2a', 'sa-2c'];
const PROFILI_CON_PROGETTO = ['sa-2b', 'sa-4'];

export default function AvvioPanel({ opzioni, statoOpzioni, erroreOpzioni, onRiprova, onAvvia, disabilitato }) {
  const profili = Array.isArray(opzioni?.profili) ? opzioni.profili : [];
  const modelli = Array.isArray(opzioni?.modelli) ? opzioni.modelli : [];

  const [profilo, setProfilo] = useState('');
  const [modello, setModello] = useState('');
  const [nome, setNome] = useState('');
  const [tempoTrascorso, setTempoTrascorso] = useState('');
  const [progetto, setProgetto] = useState('');

  // Valori iniziali appena arrivano le opzioni
  useEffect(() => {
    if (!profilo && profili.length) setProfilo(profili[0].codice);
    if (!modello && modelli.length) {
      const def = modelli.find((m) => m.id === opzioni?.default_modello);
      setModello(def ? def.id : modelli[0].id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opzioni]);

  const p = (profilo || '').toLowerCase();
  const mostraTempo = PROFILI_CON_TEMPO.includes(p);
  const mostraProgetto = PROFILI_CON_PROGETTO.includes(p);

  const avvia = (e) => {
    e.preventDefault();
    if (!profilo || !modello) return;
    onAvvia({
      profilo,
      modello,
      nome,
      tempoTrascorso: mostraTempo ? tempoTrascorso : '',
      progetto: mostraProgetto ? progetto : '',
    });
  };

  if (statoOpzioni === 'loading') {
    return (
      <div className="card">
        <div className="skeleton-line" style={{ width: '60%' }} />
        <div className="skeleton-line" style={{ width: '40%' }} />
      </div>
    );
  }

  if (statoOpzioni === 'error') {
    return (
      <div className="card state-error">
        Impossibile caricare profili e modelli disponibili.
        <div><button type="button" className="btn-link" onClick={onRiprova}>Riprova</button></div>
        <ErrorDetails error={erroreOpzioni} />
      </div>
    );
  }

  const descrizioneProfilo = profili.find((x) => x.codice === profilo)?.descrizione;

  return (
    <form className="card salab-avvio" onSubmit={avvia}>
      <div className="salab-avvio-grid">
        <label>
          <span className="field-label">Profilo</span>
          <select className="field-select" value={profilo} onChange={(e) => setProfilo(e.target.value)} disabled={disabilitato}>
            {profili.map((x) => (
              <option key={x.codice} value={x.codice}>
                {x.codice}{x.descrizione ? ` · ${x.descrizione}` : ''}
              </option>
            ))}
          </select>
        </label>
        <label>
          <span className="field-label">Modello</span>
          <select className="field-select" value={modello} onChange={(e) => setModello(e.target.value)} disabled={disabilitato}>
            {modelli.map((m) => (
              <option key={m.id} value={m.id}>
                {m.etichetta || m.id} · {m.locale ? 'locale' : 'cloud'}
                {m.id === opzioni?.default_modello ? ' (predefinito)' : ''}
              </option>
            ))}
          </select>
        </label>
        <label>
          <span className="field-label">Nome (facoltativo)</span>
          <input
            className="field-input"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            placeholder="es. Giulia"
            disabled={disabilitato}
          />
        </label>
        {mostraTempo && (
          <label>
            <span className="field-label">Tempo trascorso (facoltativo)</span>
            <input
              className="field-input"
              value={tempoTrascorso}
              onChange={(e) => setTempoTrascorso(e.target.value)}
              placeholder="es. 3 mesi"
              disabled={disabilitato}
            />
          </label>
        )}
        {mostraProgetto && (
          <label>
            <span className="field-label">Progetto (facoltativo)</span>
            <input
              className="field-input"
              value={progetto}
              onChange={(e) => setProgetto(e.target.value)}
              placeholder="es. Migrazione cloud"
              disabled={disabilitato}
            />
          </label>
        )}
      </div>
      <div className="salab-avvio-azioni">
        {descrizioneProfilo && <span className="salab-muted salab-xs">{descrizioneProfilo}</span>}
        <button type="submit" className="btn btn-primary" disabled={disabilitato || !profilo || !modello}>
          {disabilitato ? 'Avvio…' : 'Avvia'}
        </button>
      </div>
    </form>
  );
}
